import { render, staticRenderFns } from "./AutenticidadeQr.vue?vue&type=template&id=15f1a712&"
import script from "./AutenticidadeQr.vue?vue&type=script&lang=js&"
export * from "./AutenticidadeQr.vue?vue&type=script&lang=js&"
import style0 from "./AutenticidadeQr.vue?vue&type=style&index=0&id=15f1a712&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports